module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"section":{"prefix":"Other ","title":"{prefix}Recruiting Fair"}}}')
  delete Component.options._Ctor
}
